// src/components/tarifs/OptionalAddonsSection.js
import React from 'react';
import './OptionalAddonsSection.css'; // Importe son propre CSS

function OptionalAddonsSection({ addons }) {
  const fallbackAddons = [
    {
      id: 'addon1',
      name: "Module E-commerce Avancé",
      description: "Fonctionnalités e-commerce étendues : gestion de promotions, avis clients, multi-devises, etc.",
      price: "À partir de 450€",
      priceNote: ""
    },
    {
      id: 'addon2',
      name: "Rédaction de Contenu SEO (par page)",
      description: "Création de textes optimisés pour le référencement naturel et engageants pour vos visiteurs.",
      price: "80€",
      priceNote: "/ page"
    },
    {
      id: 'addon3',
      name: "Création de Logo & Identité Visuelle",
      description: "Conception de votre logo et des éléments clés de votre charte graphique.",
      price: "Sur devis",
      priceNote: ""
    },
    {
      id: 'addon4',
      name: "Hébergement Web Premium",
      description: "Solution d'hébergement performante, sécurisée et avec sauvegardes régulières.",
      price: "150€",
      priceNote: "/ an"
    },
    {
      id: 'addon5',
      name: "Maintenance Mensuelle Étendue",
      description: "Pack de maintenance incluant mises à jour, support technique prioritaire et modifications mineures.",
      price: "À partir de 75€",
      priceNote: "/ mois"
    }
    // Ajoute d'autres options
  ];

  const data = Array.isArray(addons) && addons.length ? addons : fallbackAddons;

  return (
    <section className="optional-addons-container">
      <h2 className="section-title">Options et Services Complémentaires</h2>
      <div className="addons-tax-legend">(Prix en HT / TTC selon l’option)</div>
      <div className="addons-list">
        {data.map(addon => (
          <div key={addon.id} className="addon-card">
            <h3>{addon.name}</h3>
            <p className="addon-description">{addon.description}</p>
            <p className="addon-price">
              {(() => {
                const rawPrice = addon.price;
                const priceStr = (typeof rawPrice === 'string') ? rawPrice : '';
                const hasTaxSuffix = priceStr.endsWith(' HT') || priceStr.endsWith(' TTC');
                const priceMain = hasTaxSuffix ? priceStr.slice(0, priceStr.lastIndexOf(' ')) : priceStr;
                const priceTax = hasTaxSuffix ? priceStr.slice(priceStr.lastIndexOf(' ') + 1) : '';
                return hasTaxSuffix ? (
                  <>
                    {priceMain}
                    <span className="addon-price-tax">{priceTax}</span>
                  </>
                ) : (
                  rawPrice
                );
              })()}
              {addon.priceNote && <span className="price-note"> {addon.priceNote}</span>}
            </p>
            {/* Tu pourrais ajouter un petit lien "En savoir plus" ou "Ajouter au devis" ici */}
          </div>
        ))}
      </div>
      <p style={{textAlign: 'center', marginTop: '2rem', fontSize: '0.9rem', color: 'var(--secondary-color)'}}>
        Ces options peuvent être discutées et ajoutées à votre projet. Contactez-nous pour un devis personnalisé.
      </p>
    </section>
  );
}

export default OptionalAddonsSection;